<app-shared-business-metadata-v2 [metadata]="metadata" />

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="!isIjmInfoEmpty(metadata) || !isIjmInfoEmpty(originalMetadata)"
>
  <div cardTitle i18n>Informations Assurance IJM</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          metadata?.womenCount !== undefined ||
          originalMetadata?.womenCount !== undefined
        "
      >
        <span class="card__label" i18n>Nombre de femmes</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.womenCount !== metadata.womenCount,
            }"
            >{{ metadata.womenCount }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.womenCount !== metadata.womenCount &&
              originalMetadata.womenCount !== null &&
              originalMetadata.womenCount !== undefined
            "
            >{{ originalMetadata.womenCount }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.womenAverageAge !== undefined ||
          originalMetadata?.womenAverageAge !== undefined
        "
      >
        <span class="card__label" i18n>Âge moyen des femmes</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.womenAverageAge !== metadata.womenAverageAge,
            }"
            >{{ metadata.womenAverageAge }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.womenAverageAge !== metadata.womenAverageAge &&
              originalMetadata.womenAverageAge !== null &&
              originalMetadata.womenAverageAge !== undefined
            "
            >{{ originalMetadata.womenAverageAge }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.womenTotalSalary !== undefined ||
          originalMetadata?.womenTotalSalary !== undefined
        "
      >
        <span class="card__label" i18n>Masse salariale femmes</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.womenTotalSalary !== metadata.womenTotalSalary,
            }"
            >{{ metadata.womenTotalSalary }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.womenTotalSalary !== metadata.womenTotalSalary &&
              originalMetadata.womenTotalSalary !== null &&
              originalMetadata.womenTotalSalary !== undefined
            "
            >{{ originalMetadata.womenTotalSalary }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.coveragePercent !== undefined ||
          originalMetadata?.coveragePercent !== undefined
        "
      >
        <span class="card__label" i18n>Pourcentage de couverture</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.coveragePercent !== metadata.coveragePercent,
            }"
            >{{ metadata.coveragePercent }}%</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.coveragePercent !== metadata.coveragePercent &&
              originalMetadata.coveragePercent !== null &&
              originalMetadata.coveragePercent !== undefined
            "
            >{{ originalMetadata.coveragePercent }}%</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          metadata?.menCount !== undefined ||
          originalMetadata?.menCount !== undefined
        "
      >
        <span class="card__label" i18n>Nombre d'hommes</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.menCount !== metadata.menCount,
            }"
            >{{ metadata.menCount }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.menCount !== metadata.menCount &&
              originalMetadata.menCount !== null &&
              originalMetadata.menCount !== undefined
            "
            >{{ originalMetadata.menCount }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.menAverageAge !== undefined ||
          originalMetadata?.menAverageAge !== undefined
        "
      >
        <span class="card__label" i18n>Âge moyen des hommes</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.menAverageAge !== metadata.menAverageAge,
            }"
            >{{ metadata.menAverageAge }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.menAverageAge !== metadata.menAverageAge &&
              originalMetadata.menAverageAge !== null &&
              originalMetadata.menAverageAge !== undefined
            "
            >{{ originalMetadata.menAverageAge }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.menTotalSalary !== undefined ||
          originalMetadata?.menTotalSalary !== undefined
        "
      >
        <span class="card__label" i18n>Masse salariale hommes</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.menTotalSalary !== metadata.menTotalSalary,
            }"
            >{{ metadata.menTotalSalary }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.menTotalSalary !== metadata.menTotalSalary &&
              originalMetadata.menTotalSalary !== null &&
              originalMetadata.menTotalSalary !== undefined
            "
            >{{ originalMetadata.menTotalSalary }} CHF</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isInsuredPersonsEmpty(metadata?.insuredPersons) ||
    metadata?.allCollaboratorsCovered !== undefined ||
    !isInsuredPersonsEmpty(originalMetadata?.insuredPersons) ||
    originalMetadata?.allCollaboratorsCovered !== undefined
  "
>
  <div cardTitle i18n>Cercle des personnes assurées</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div class="card__row">
        <span class="card__label" i18n>Tous les collaborateurs assurés</span>
        <span class="card__value">
          {{ getBooleanLabel(metadata.allCollaboratorsCovered) }}
        </span>
      </div>
      <div class="card__row" *ngFor="let person of metadata?.insuredPersons">
        <span class="card__label">{{ person.fullName }}</span>
        <span *ngIf="person.collaboratorId">
          <a
            (click)="viewCollaborator(person.collaboratorId)"
            class="clickable"
            i18n
            >Voir le collaborateur</a
          >
        </span>
        <span class="card__value" *ngIf="!person.collaboratorId"></span>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isContractInfoEmpty(metadata) || !isContractInfoEmpty(originalMetadata)
  "
>
  <div cardTitle i18n>Informations du contrat</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="metadata?.startDate || originalMetadata?.startDate"
      >
        <span class="card__label" i18n>Date de début</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.startDate | customDate) !==
                  (metadata.startDate | customDate),
            }"
            >{{ metadata.startDate | customDate }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              (originalMetadata.startDate | customDate) !==
                (metadata.startDate | customDate) &&
              (originalMetadata.startDate | customDate) !== null &&
              (originalMetadata.startDate | customDate) !== undefined
            "
            >{{ originalMetadata.startDate | customDate }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.contractDuration || originalMetadata?.contractDuration"
      >
        <span class="card__label" i18n>Durée du contrat</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.contractDuration | customDate) !==
                  (metadata.contractDuration | customDate),
            }"
            >{{ metadata.contractDuration | customDate }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              (originalMetadata.contractDuration | customDate) !==
                (metadata.contractDuration | customDate) &&
              (originalMetadata.contractDuration | customDate) !== null &&
              (originalMetadata.contractDuration | customDate) !== undefined
            "
            >{{ originalMetadata.contractDuration | customDate }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.paymentFrequency || originalMetadata?.paymentFrequency"
      >
        <span class="card__label" i18n>Mode de paiement</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getPaymentFrequencyLabel(originalMetadata.paymentFrequency) !==
                  getPaymentFrequencyLabel(metadata.paymentFrequency),
            }"
            >{{ getPaymentFrequencyLabel(metadata.paymentFrequency) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getPaymentFrequencyLabel(originalMetadata.paymentFrequency) !==
                getPaymentFrequencyLabel(metadata.paymentFrequency) &&
              getPaymentFrequencyLabel(originalMetadata.paymentFrequency) !==
                null &&
              getPaymentFrequencyLabel(originalMetadata.paymentFrequency) !==
                undefined
            "
            >{{
              getPaymentFrequencyLabel(originalMetadata.paymentFrequency)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.splitPaymentFee !== null &&
            metadata?.splitPaymentFee !== undefined) ||
          (originalMetadata?.splitPaymentFee !== null &&
            originalMetadata?.splitPaymentFee !== undefined)
        "
      >
        <span class="card__label" i18n
          >Supplément pour paiement fractionné en %</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.splitPaymentFee !== metadata.splitPaymentFee,
            }"
            >{{ metadata.splitPaymentFee }}%</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.splitPaymentFee !== metadata.splitPaymentFee &&
              originalMetadata.splitPaymentFee !== null &&
              originalMetadata.splitPaymentFee !== undefined
            "
            >{{ originalMetadata.splitPaymentFee }}%</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isCoveragesEmpty(metadata?.coverages) ||
    !isCoveragesEmpty(originalMetadata?.coverages)
  "
>
  <div cardTitle i18n>Prestations assurées</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          metadata?.coverages?.coverage || originalMetadata?.coverages?.coverage
        "
      >
        <span class="card__label" i18n>Couverture</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.coverages.coverage !==
                  metadata.coverages.coverage,
            }"
            >{{ metadata.coverages.coverage }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.coverages.coverage !==
                metadata.coverages.coverage &&
              originalMetadata.coverages.coverage !== null &&
              originalMetadata.coverages.coverage !== undefined
            "
            >{{ originalMetadata.coverages.coverage }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.coverages?.insuredSalaryRate ||
          originalMetadata?.coverages?.insuredSalaryRate
        "
      >
        <span class="card__label" i18n>Taux de salaire assuré</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBusinessInsuredSalaryRateLabel(
                  originalMetadata.coverages.insuredSalaryRate
                ) !==
                  getBusinessInsuredSalaryRateLabel(
                    metadata.coverages.insuredSalaryRate
                  ),
            }"
            >{{
              getBusinessInsuredSalaryRateLabel(
                metadata.coverages.insuredSalaryRate
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBusinessInsuredSalaryRateLabel(
                originalMetadata.coverages.insuredSalaryRate
              ) !==
                getBusinessInsuredSalaryRateLabel(
                  metadata.coverages.insuredSalaryRate
                ) &&
              getBusinessInsuredSalaryRateLabel(
                originalMetadata.coverages.insuredSalaryRate
              ) !== null &&
              getBusinessInsuredSalaryRateLabel(
                originalMetadata.coverages.insuredSalaryRate
              ) !== undefined
            "
            >{{
              getBusinessInsuredSalaryRateLabel(
                originalMetadata.coverages.insuredSalaryRate
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.coverages?.waitingDelay ||
          originalMetadata?.coverages?.waitingDelay
        "
      >
        <span class="card__label" i18n>Délai d'attente en jours</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBusinessWaitingDaysLabel(
                  originalMetadata.coverages.waitingDelay
                ) !==
                  getBusinessWaitingDaysLabel(metadata.coverages.waitingDelay),
            }"
            >{{
              getBusinessWaitingDaysLabel(metadata.coverages.waitingDelay)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBusinessWaitingDaysLabel(
                originalMetadata.coverages.waitingDelay
              ) !==
                getBusinessWaitingDaysLabel(metadata.coverages.waitingDelay) &&
              getBusinessWaitingDaysLabel(
                originalMetadata.coverages.waitingDelay
              ) !== null &&
              getBusinessWaitingDaysLabel(
                originalMetadata.coverages.waitingDelay
              ) !== undefined
            "
            >{{
              getBusinessWaitingDaysLabel(
                originalMetadata.coverages.waitingDelay
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.coverages?.coverageDurationDays ||
          originalMetadata?.coverages?.coverageDurationDays
        "
      >
        <span class="card__label" i18n>Durée des prestations en jours</span>
        <span class="card__value">{{
          getBusinessCoverageDurationDaysLabel(
            metadata.coverages.coverageDurationDays
          )
        }}</span>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.coverages?.coverageSystem ||
          originalMetadata?.coverages?.coverageSystem
        "
      >
        <span class="card__label" i18n>Système selon</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBusinessHealthCoverageSystemLabel(
                  originalMetadata.coverages.coverageSystem
                ) !==
                  getBusinessHealthCoverageSystemLabel(
                    metadata.coverages.coverageSystem
                  ),
            }"
            >{{
              getBusinessHealthCoverageSystemLabel(
                metadata.coverages.coverageSystem
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBusinessHealthCoverageSystemLabel(
                originalMetadata.coverages.coverageSystem
              ) !==
                getBusinessHealthCoverageSystemLabel(
                  metadata.coverages.coverageSystem
                ) &&
              getBusinessHealthCoverageSystemLabel(
                originalMetadata.coverages.coverageSystem
              ) !== null &&
              getBusinessHealthCoverageSystemLabel(
                originalMetadata.coverages.coverageSystem
              ) !== undefined
            "
            >{{
              getBusinessHealthCoverageSystemLabel(
                originalMetadata.coverages.coverageSystem
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.coverages?.invalidityDurationForCoverage ||
          originalMetadata?.coverages?.invalidityDurationForCoverage
        "
      >
        <span class="card__label" i18n>Couverture dès une incapacité de</span>
        <span class="card__value">{{
          getBusinessInvalidityDurationLabel(
            metadata.coverages.invalidityDurationForCoverage
          )
        }}</span>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages?.salaryDueDeath !== null &&
            metadata?.coverages?.salaryDueDeath !== undefined) ||
          (originalMetadata?.coverages?.salaryDueDeath !== null &&
            originalMetadata?.coverages?.salaryDueDeath !== undefined)
        "
      >
        <span class="card__label" i18n
          >Salaire dû en cas de décès selon l'art. 338 CO</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.coverages.salaryDueDeath) !==
                  getBooleanLabel(metadata.coverages.salaryDueDeath),
            }"
            >{{ getBooleanLabel(metadata.coverages.salaryDueDeath) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.coverages.salaryDueDeath) !==
                getBooleanLabel(metadata.coverages.salaryDueDeath) &&
              getBooleanLabel(originalMetadata.coverages.salaryDueDeath) !==
                null &&
              getBooleanLabel(originalMetadata.coverages.salaryDueDeath) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata.coverages.salaryDueDeath)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages?.maternitySupplement !== null &&
            metadata?.coverages?.maternitySupplement !== undefined) ||
          (originalMetadata?.coverages?.maternitySupplement !== null &&
            originalMetadata?.coverages?.maternitySupplement !== undefined)
        "
      >
        <span class="card__label" i18n>Complément maternité</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.coverages.maternitySupplement
                ) !== getBooleanLabel(metadata.coverages.maternitySupplement),
            }"
            >{{ getBooleanLabel(metadata.coverages.maternitySupplement) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.coverages.maternitySupplement
              ) !== getBooleanLabel(metadata.coverages.maternitySupplement) &&
              getBooleanLabel(
                originalMetadata.coverages.maternitySupplement
              ) !== null &&
              getBooleanLabel(
                originalMetadata.coverages.maternitySupplement
              ) !== undefined
            "
            >{{
              getBooleanLabel(originalMetadata.coverages.maternitySupplement)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.coverages?.maternityCoverageDuration ||
          originalMetadata?.coverages?.maternityCoverageDuration
        "
      >
        <span class="card__label" i18n
          >Durée des prestations maternité en jours</span
        >
        <span class="card__value">{{
          getBusinessMaternityCoverageDurationLabel(
            metadata.coverages.maternityCoverageDuration
          )
        }}</span>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages?.maternityCoverages &&
            metadata.coverages.maternityCoverages.length > 0) ||
          (originalMetadata?.coverages?.maternityCoverages &&
            originalMetadata.coverages.maternityCoverages.length > 0)
        "
      >
        <span class="card__label" i18n>Prestations assurée en maternité</span>
        <div class="d-flex flex-column gap-1 card__value">
          <span>
            <div *ngFor="let coverage of metadata.coverages.maternityCoverages">
              {{ getBusinessMaternityCoverageLabel(coverage) }}
            </div>
          </span>
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages?.durationExtension !== null &&
            metadata?.coverages?.durationExtension !== undefined) ||
          (originalMetadata?.coverages?.durationExtension !== null &&
            originalMetadata?.coverages?.durationExtension !== undefined)
        "
      >
        <span class="card__label" i18n>Prolongation de durée</span>
        <span class="card__value"
          >{{ metadata.coverages.durationExtension }}
          <ng-container i18n>jours</ng-container></span
        >
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.coverages?.coverageWaitingDelay ||
          originalMetadata?.coverages?.coverageWaitingDelay
        "
      >
        <span class="card__label" i18n>Délai d'attente en jours</span>
        <span class="card__value">{{
          getBusinessHealthCoverageWaitingDelayLabel(
            metadata.coverages.coverageWaitingDelay
          )
        }}</span>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages?.maximumInsuredSalary !== null &&
            metadata?.coverages?.maximumInsuredSalary !== undefined) ||
          (originalMetadata?.coverages?.maximumInsuredSalary !== null &&
            originalMetadata?.coverages?.maximumInsuredSalary !== undefined)
        "
      >
        <span class="card__label" i18n>Salaire maximum assuré</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.coverages.maximumInsuredSalary !==
                  metadata.coverages.maximumInsuredSalary,
            }"
            >{{ metadata.coverages.maximumInsuredSalary }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.coverages.maximumInsuredSalary !==
                metadata.coverages.maximumInsuredSalary &&
              originalMetadata.coverages.maximumInsuredSalary !== null &&
              originalMetadata.coverages.maximumInsuredSalary !== undefined
            "
            >{{ originalMetadata.coverages.maximumInsuredSalary }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.coverages?.breastfeedingAllowance !== null &&
            metadata?.coverages?.breastfeedingAllowance !== undefined) ||
          (originalMetadata?.coverages?.breastfeedingAllowance !== null &&
            originalMetadata?.coverages?.breastfeedingAllowance !== undefined)
        "
      >
        <span class="card__label" i18n>Indemnité d'allaitement</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.coverages.breastfeedingAllowance
                ) !==
                  getBooleanLabel(metadata.coverages.breastfeedingAllowance),
            }"
            >{{
              getBooleanLabel(metadata.coverages.breastfeedingAllowance)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.coverages.breastfeedingAllowance
              ) !==
                getBooleanLabel(metadata.coverages.breastfeedingAllowance) &&
              getBooleanLabel(
                originalMetadata.coverages.breastfeedingAllowance
              ) !== null &&
              getBooleanLabel(
                originalMetadata.coverages.breastfeedingAllowance
              ) !== undefined
            "
            >{{
              getBooleanLabel(originalMetadata.coverages.breastfeedingAllowance)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.coverages?.breastfeedingAllowanceDuration ||
          originalMetadata?.coverages?.breastfeedingAllowanceDuration
        "
      >
        <span class="card__label" i18n>Durée</span>
        <span class="card__value">{{
          getBusinessCoverageDurationDaysLabel(
            metadata.coverages.breastfeedingAllowanceDuration
          )
        }}</span>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.coverages?.menRate || originalMetadata?.coverages?.menRate
        "
      >
        <span class="card__label" i18n>Taux hommes</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.coverages.menRate !==
                  metadata.coverages.menRate,
            }"
            >{{ metadata.coverages.menRate }}%</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.coverages.menRate !==
                metadata.coverages.menRate &&
              originalMetadata.coverages.menRate !== null &&
              originalMetadata.coverages.menRate !== undefined
            "
            >{{ originalMetadata.coverages.menRate }}%</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.coverages?.womenRate ||
          originalMetadata?.coverages?.womenRate
        "
      >
        <span class="card__label" i18n>Taux femmes</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.coverages.womenRate !==
                  metadata.coverages.womenRate,
            }"
            >{{ metadata.coverages.womenRate }}%</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.coverages.womenRate !==
                metadata.coverages.womenRate &&
              originalMetadata.coverages.womenRate !== null &&
              originalMetadata.coverages.womenRate !== undefined
            "
            >{{ originalMetadata.coverages.womenRate }}%</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isSupplementaryCoveragesEmpty(metadata?.supplementaryCoverages) ||
    !isSupplementaryCoveragesEmpty(originalMetadata?.supplementaryCoverages)
  "
>
  <div cardTitle i18n>Conditions complémentaires</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.supplementaryCoverages?.unpaidLeaveCovered !== null &&
            metadata?.supplementaryCoverages?.unpaidLeaveCovered !==
              undefined) ||
          (originalMetadata?.supplementaryCoverages?.unpaidLeaveCovered !==
            null &&
            originalMetadata?.supplementaryCoverages?.unpaidLeaveCovered !==
              undefined)
        "
      >
        <span class="card__label" i18n
          >Couverture durant les congés non payés</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.supplementaryCoverages.unpaidLeaveCovered
                ) !==
                  getBooleanLabel(
                    metadata.supplementaryCoverages.unpaidLeaveCovered
                  ),
            }"
            >{{
              getBooleanLabel(
                metadata.supplementaryCoverages.unpaidLeaveCovered
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.unpaidLeaveCovered
              ) !==
                getBooleanLabel(
                  metadata.supplementaryCoverages.unpaidLeaveCovered
                ) &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.unpaidLeaveCovered
              ) !== null &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.unpaidLeaveCovered
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.unpaidLeaveCovered
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.supplementaryCoverages?.trialPeriodCovered !== null &&
            metadata?.supplementaryCoverages?.trialPeriodCovered !==
              undefined) ||
          (originalMetadata?.supplementaryCoverages?.trialPeriodCovered !==
            null &&
            originalMetadata?.supplementaryCoverages?.trialPeriodCovered !==
              undefined)
        "
      >
        <span class="card__label" i18n>Couverture durant le temps d'essai</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.supplementaryCoverages.trialPeriodCovered
                ) !==
                  getBooleanLabel(
                    metadata.supplementaryCoverages.trialPeriodCovered
                  ),
            }"
            >{{
              getBooleanLabel(
                metadata.supplementaryCoverages.trialPeriodCovered
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.trialPeriodCovered
              ) !==
                getBooleanLabel(
                  metadata.supplementaryCoverages.trialPeriodCovered
                ) &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.trialPeriodCovered
              ) !== null &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.trialPeriodCovered
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.trialPeriodCovered
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.supplementaryCoverages?.cddCovered !== null &&
            metadata?.supplementaryCoverages?.cddCovered !== undefined) ||
          (originalMetadata?.supplementaryCoverages?.cddCovered !== null &&
            originalMetadata?.supplementaryCoverages?.cddCovered !== undefined)
        "
      >
        <span class="card__label" i18n
          >Couverture pour le personnel avec un CDD</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.supplementaryCoverages.cddCovered
                ) !==
                  getBooleanLabel(metadata.supplementaryCoverages.cddCovered),
            }"
            >{{
              getBooleanLabel(metadata.supplementaryCoverages.cddCovered)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.cddCovered
              ) !==
                getBooleanLabel(metadata.supplementaryCoverages.cddCovered) &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.cddCovered
              ) !== null &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.cddCovered
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.cddCovered
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.supplementaryCoverages?.pregnancyCovered !== null &&
            metadata?.supplementaryCoverages?.pregnancyCovered !== undefined) ||
          (originalMetadata?.supplementaryCoverages?.pregnancyCovered !==
            null &&
            originalMetadata?.supplementaryCoverages?.pregnancyCovered !==
              undefined)
        "
      >
        <span class="card__label" i18n
          >Couverture pour les femmes enceintes durant l'engagement</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.supplementaryCoverages.pregnancyCovered
                ) !==
                  getBooleanLabel(
                    metadata.supplementaryCoverages.pregnancyCovered
                  ),
            }"
            >{{
              getBooleanLabel(metadata.supplementaryCoverages.pregnancyCovered)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.pregnancyCovered
              ) !==
                getBooleanLabel(
                  metadata.supplementaryCoverages.pregnancyCovered
                ) &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.pregnancyCovered
              ) !== null &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.pregnancyCovered
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.pregnancyCovered
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.supplementaryCoverages?.excessSalaryCovered !== null &&
            metadata?.supplementaryCoverages?.excessSalaryCovered !==
              undefined) ||
          (originalMetadata?.supplementaryCoverages?.excessSalaryCovered !==
            null &&
            originalMetadata?.supplementaryCoverages?.excessSalaryCovered !==
              undefined)
        "
      >
        <span class="card__label" i18n
          >Participation à l'excédant de primes</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.supplementaryCoverages.excessSalaryCovered
                ) !==
                  getBooleanLabel(
                    metadata.supplementaryCoverages.excessSalaryCovered
                  ),
            }"
            >{{
              getBooleanLabel(
                metadata.supplementaryCoverages.excessSalaryCovered
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.excessSalaryCovered
              ) !==
                getBooleanLabel(
                  metadata.supplementaryCoverages.excessSalaryCovered
                ) &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.excessSalaryCovered
              ) !== null &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.excessSalaryCovered
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.excessSalaryCovered
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.supplementaryCoverages?.premiumSurplusComputingPeriod ||
          originalMetadata?.supplementaryCoverages
            ?.premiumSurplusComputingPeriod
        "
      >
        <span class="card__label" i18n>Si oui, période de calcul</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.supplementaryCoverages
                  .premiumSurplusComputingPeriod !==
                  metadata.supplementaryCoverages.premiumSurplusComputingPeriod,
            }"
            >{{
              metadata.supplementaryCoverages.premiumSurplusComputingPeriod
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.supplementaryCoverages
                .premiumSurplusComputingPeriod !==
                metadata.supplementaryCoverages.premiumSurplusComputingPeriod &&
              originalMetadata.supplementaryCoverages
                .premiumSurplusComputingPeriod !== null &&
              originalMetadata.supplementaryCoverages
                .premiumSurplusComputingPeriod !== undefined
            "
            >{{
              originalMetadata.supplementaryCoverages
                .premiumSurplusComputingPeriod
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.supplementaryCoverages?.fixedPremiumRate !== null &&
            metadata?.supplementaryCoverages?.fixedPremiumRate !== undefined) ||
          (originalMetadata?.supplementaryCoverages?.fixedPremiumRate !==
            null &&
            originalMetadata?.supplementaryCoverages?.fixedPremiumRate !==
              undefined)
        "
      >
        <span class="card__label" i18n
          >Garantie du taux de prime pendant la durée du contrat</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.supplementaryCoverages.fixedPremiumRate
                ) !==
                  getBooleanLabel(
                    metadata.supplementaryCoverages.fixedPremiumRate
                  ),
            }"
            >{{
              getBooleanLabel(metadata.supplementaryCoverages.fixedPremiumRate)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.fixedPremiumRate
              ) !==
                getBooleanLabel(
                  metadata.supplementaryCoverages.fixedPremiumRate
                ) &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.fixedPremiumRate
              ) !== null &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.fixedPremiumRate
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.fixedPremiumRate
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.supplementaryCoverages?.claimTerminationWaiver !== null &&
            metadata?.supplementaryCoverages?.claimTerminationWaiver !==
              undefined) ||
          (originalMetadata?.supplementaryCoverages?.claimTerminationWaiver !==
            null &&
            originalMetadata?.supplementaryCoverages?.claimTerminationWaiver !==
              undefined)
        "
      >
        <span class="card__label" i18n
          >Renonciation à la résiliation sur sinistres</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.supplementaryCoverages.claimTerminationWaiver
                ) !==
                  getBooleanLabel(
                    metadata.supplementaryCoverages.claimTerminationWaiver
                  ),
            }"
            >{{
              getBooleanLabel(
                metadata.supplementaryCoverages.claimTerminationWaiver
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.claimTerminationWaiver
              ) !==
                getBooleanLabel(
                  metadata.supplementaryCoverages.claimTerminationWaiver
                ) &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.claimTerminationWaiver
              ) !== null &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.claimTerminationWaiver
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.claimTerminationWaiver
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.supplementaryCoverages?.guaranteedCaseFollowup !== null &&
            metadata?.supplementaryCoverages?.guaranteedCaseFollowup !==
              undefined) ||
          (originalMetadata?.supplementaryCoverages?.guaranteedCaseFollowup !==
            null &&
            originalMetadata?.supplementaryCoverages?.guaranteedCaseFollowup !==
              undefined)
        "
      >
        <span class="card__label" i18n
          >Garantie de la reprise des cas en cours</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.supplementaryCoverages.guaranteedCaseFollowup
                ) !==
                  getBooleanLabel(
                    metadata.supplementaryCoverages.guaranteedCaseFollowup
                  ),
            }"
            >{{
              getBooleanLabel(
                metadata.supplementaryCoverages.guaranteedCaseFollowup
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.guaranteedCaseFollowup
              ) !==
                getBooleanLabel(
                  metadata.supplementaryCoverages.guaranteedCaseFollowup
                ) &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.guaranteedCaseFollowup
              ) !== null &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.guaranteedCaseFollowup
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.guaranteedCaseFollowup
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.supplementaryCoverages?.tacitRenewal !== null &&
            metadata?.supplementaryCoverages?.tacitRenewal !== undefined) ||
          (originalMetadata?.supplementaryCoverages?.tacitRenewal !== null &&
            originalMetadata?.supplementaryCoverages?.tacitRenewal !==
              undefined)
        "
      >
        <span class="card__label" i18n>Renouvellement tacite</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.supplementaryCoverages.tacitRenewal
                ) !==
                  getBooleanLabel(metadata.supplementaryCoverages.tacitRenewal),
            }"
            >{{
              getBooleanLabel(metadata.supplementaryCoverages.tacitRenewal)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.tacitRenewal
              ) !==
                getBooleanLabel(metadata.supplementaryCoverages.tacitRenewal) &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.tacitRenewal
              ) !== null &&
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.tacitRenewal
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.supplementaryCoverages.tacitRenewal
              )
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isCurrentInsuranceEmpty(metadata) ||
    !isCurrentInsuranceEmpty(originalMetadata)
  "
>
  <div cardTitle i18n>Assurance actuelle</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.hasInsurance !== null &&
            metadata?.hasInsurance !== undefined) ||
          (originalMetadata?.hasInsurance !== null &&
            originalMetadata?.hasInsurance !== undefined)
        "
      >
        <span class="card__label" i18n>Possède une assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.hasInsurance) !==
                  getBooleanLabel(metadata.hasInsurance),
            }"
            >{{ getBooleanLabel(metadata.hasInsurance) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.hasInsurance) !==
                getBooleanLabel(metadata.hasInsurance) &&
              getBooleanLabel(originalMetadata.hasInsurance) !== null &&
              getBooleanLabel(originalMetadata.hasInsurance) !== undefined
            "
            >{{ getBooleanLabel(originalMetadata.hasInsurance) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.currentInsurer || originalMetadata?.currentInsurer"
      >
        <span class="card__label" i18n>Assureur actuel</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.currentInsurer !== metadata.currentInsurer,
            }"
            >{{ metadata.currentInsurer }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.currentInsurer !== metadata.currentInsurer &&
              originalMetadata.currentInsurer !== null &&
              originalMetadata.currentInsurer !== undefined
            "
            >{{ originalMetadata.currentInsurer }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.hasClaimsLastFiveYears !== null &&
            metadata?.hasClaimsLastFiveYears !== undefined) ||
          (originalMetadata?.hasClaimsLastFiveYears !== null &&
            originalMetadata?.hasClaimsLastFiveYears !== undefined)
        "
      >
        <span class="card__label" i18n
          >A subi des sinistres ces 5 dernières années</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.hasClaimsLastFiveYears) !==
                  getBooleanLabel(metadata.hasClaimsLastFiveYears),
            }"
            >{{ getBooleanLabel(metadata.hasClaimsLastFiveYears) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.hasClaimsLastFiveYears) !==
                getBooleanLabel(metadata.hasClaimsLastFiveYears) &&
              getBooleanLabel(originalMetadata.hasClaimsLastFiveYears) !==
                null &&
              getBooleanLabel(originalMetadata.hasClaimsLastFiveYears) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata.hasClaimsLastFiveYears)
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>
